import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { MarkdownPipe } from '../../../../../shared/pipes/markdown.pipe';
import { TemplateMetadataPipe } from '../../../../../shared/pipes/template-metadata.pipe';

@Component({
  selector: 'app-text-label-field',
  standalone: true,
  imports: [CommonModule, MarkdownPipe, TemplateMetadataPipe],
  templateUrl: './text-label-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./text-label-field.component.css'],
})
export class TextLabelFieldComponent extends FieldType<FieldTypeConfig> {}
